import { takeLatest } from "redux-saga/effects";

import { FETCH_PREMIER_COLLECTION_SHOP, CHECK_LIFESTYLE_ELIGIBILITY } from "../actions/constants";
import fetchPremierCollectionShopSaga from "./fetchPremierCollectionShopSaga";
import checkLifestyleEligibilitySaga from "./checkLifestyleEligibilitySaga";

export function* watchFetchPremierCollectionShopSaga() {
  yield takeLatest(
    FETCH_PREMIER_COLLECTION_SHOP,
    fetchPremierCollectionShopSaga
  );
}

export function* watchCheckLifestyleEligibilitySaga() {
  yield takeLatest(CHECK_LIFESTYLE_ELIGIBILITY, checkLifestyleEligibilitySaga);
}
